import { Circle as CircleStyle, Fill, Icon, Stroke, Style, Text } from "ol/style";
import { PlaceSubtype, UserStatus, SelectedStatus, RouteLayers, RoutePointDataSource } from "../enums";

//PlaceSubtype.nr1 = 1
import PlaceSubtypeNr1_DEF from "../../img/icons/objectType/placesubtype1_DEF.png";
import PlaceSubtypeNr1_ROUTE from "../../img/icons/objectType/placesubtype1_ROUTE.png";
import PlaceSubtypeNr1_VISITED from "../../img/icons/objectType/placesubtype1_VISITED.png";
import PlaceSubtypeNr1_DEF_CLICKED from "../../img/icons/objectTypeClicked/placesubtype1_zals.png";
import PlaceSubtypeNr1_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/placesubtype1_violets.png";
import PlaceSubtypeNr1_VISITED_CLICKED from "../../img/icons/objectTypeClicked/placesubtype1_peleks.png";
//PlaceSubtype.AtputasVieta = 2
import AtputasVieta_DEF from "../../img/icons/objectType/atputas_vietaDEF.png";
import AtputasVieta_ROUTE from "../../img/icons/objectType/atputas_vietaROUTE.png";
import AtputasVieta_VISITED from "../../img/icons/objectType/atputas_vietaVISITED.png";
import AtputasVieta_DEF_CLICKED from "../../img/icons/objectTypeClicked/atputas_vieta_zals.png";
import AtputasVieta_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/atputas_vieta_violets.png";
import AtputasVieta_VISITED_CLICKED from "../../img/icons/objectTypeClicked/atputas_vieta_peleks.png";
//PlaceSubtype.DabasTaka = 3
import DabasTaka_DEF from "../../img/icons/objectType/dabas_takaDEF.png";
import DabasTaka_ROUTE from "../../img/icons/objectType/dabas_takaROUTE.png";
import DabasTaka_VISITED from "../../img/icons/objectType/dabas_takaVISITED.png";
import DabasTaka_DEF_CLICKED from "../../img/icons/objectTypeClicked/dabas_taka_zals.png";
import DabasTaka_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/dabas_taka_violets.png";
import DabasTaka_VISITED_CLICKED from "../../img/icons/objectTypeClicked/dabas_taka_peleks.png";
//PlaceSubtype.AktivaAtputa_VeloTaka = 4
//PlaceSubtype.AktivaAtputa_Orientesanas = 10
import AktivaAtputa_DEF from "../../img/icons/objectType/aktiva_atputa_DEF.png";
import AktivaAtputa_ROUTE from "../../img/icons/objectType/aktiva_atputa_ROUTE.png";
import AktivaAtputa_VISITED from "../../img/icons/objectType/aktiva_atputa_VISITED.png";
import AktivaAtputa_DEF_CLICKED from "../../img/icons/objectTypeClicked/aktiva_atputa_zals.png";
import AktivaAtputa_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/aktiva_atputa_violets.png";
import AktivaAtputa_VISITED_CLICKED from "../../img/icons/objectTypeClicked/aktiva_atputa_peleks.png";
//PlaceSubtype.DabasApskatesObjekts = 5
import DabasApskatesObjekts_DEF from "../../img/icons/objectType/dabas_apskates_objekts_DEF.png";
import DabasApskatesObjekts_ROUTE from "../../img/icons/objectType/dabas_apskates_objekts_ROUTE.png";
import DabasApskatesObjekts_VISITED from "../../img/icons/objectType/dabas_apskates_objekts_VISITED.png";
import DabasApskatesObjekts_DEF_CLICKED from "../../img/icons/objectTypeClicked/dabas_apskates_objekts_zals.png";
import DabasApskatesObjekts_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/dabas_apskates_objekts_violets.png";
import DabasApskatesObjekts_VISITED_CLICKED from "../../img/icons/objectTypeClicked/dabas_apskates_objekts_peleks.png";
//PlaceSubtype.KulturvesturisksApskatesObjekts = 6
import KulturvesturisksApskatesObjekts_DEF from "../../img/icons/objectType/kulturvesturisks_apskates_objekts_DEF.png";
import KulturvesturisksApskatesObjekts_ROUTE from "../../img/icons/objectType/kulturvesturisks_apskates_objekts_ROUTE.png";
import KulturvesturisksApskatesObjekts_VISITED from "../../img/icons/objectType/kulturvesturisks_apskates_objekts_VISITED.png";
import KulturvesturisksApskatesObjekts_DEF_CLICKED from "../../img/icons/objectTypeClicked/kulturvesturisks_apskates_objekts_zals.png";
import KulturvesturisksApskatesObjekts_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/kulturvesturisks_apskates_objekts_violets.png";
import KulturvesturisksApskatesObjekts_VISITED_CLICKED from "../../img/icons/objectTypeClicked/kulturvesturisks_apskates_objekts_peleks.png";
//PlaceSubtype.MammadabaGalamerki = 7
import MammadabaGalamerki_DEF from "../../img/icons/objectType/md_galamerkisDEF.png";
import MammadabaGalamerki_ROUTE from "../../img/icons/objectType/md_galamerkisROUTE.png";
import MammadabaGalamerki_VISITED from "../../img/icons/objectType/md_galamerkisVISITED.png";
import MammadabaGalamerki_DEF_CLICKED from "../../img/icons/objectTypeClicked/lvm_objekts_zals.png";
import MammadabaGalamerki_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/lvm_objekts_violets.png";
import MammadabaGalamerki_VISITED_CLICKED from "../../img/icons/objectTypeClicked/lvm_objekts_peleks.png";
//PlaceSubtype.SkatuTornis = 9
import SkatuTornis_DEF from "../../img/icons/objectType/skatu_tornis_DEF.png";
import SkatuTornis_ROUTE from "../../img/icons/objectType/skatu_tornis_ROUTE.png";
import SkatuTornis_VISITED from "../../img/icons/objectType/skatu_tornis_VISITED.png";
import SkatuTornis_DEF_CLICKED from "../../img/icons/objectTypeClicked/skatu_tornis_zals.png";
import SkatuTornis_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/skatu_tornis_violets.png";
import SkatuTornis_VISITED_CLICKED from "../../img/icons/objectTypeClicked/skatu_tornis_peleks.png";
//PlaceSubtype.AktivaAtputa_Orientesanas = 10
// tas pats kas PlaceSubtype.AktivaAtputa_VeloTaka - abi vienā kategorijā, viena ikona

//PlaceSubtype.Udensturistiem = 11
import Udensturistiem_DEF from "../../img/icons/objectType/udensturistiem_DEFAULT.png";
import Udensturistiem_ROUTE from "../../img/icons/objectType/udensturistiem_ROUTE.png";
import Udensturistiem_VISITED from "../../img/icons/objectType/udensturistiem_VISITED.png";
import Udensturistiem_DEF_CLICKED from "../../img/icons/objectTypeClicked/udensturistiem_zals.png";
import Udensturistiem_ROUTE_CLICKED from "../../img/icons/objectTypeClicked/udensturistiem_violets.png";
import Udensturistiem_VISITED_CLICKED from "../../img/icons/objectTypeClicked/udensturistiem_peleks.png";

//Routes
import Route_DEF from "../../img/icons/objectType/routeDEF.png";
import Route_CLICKED from "../../img/icons/objectTypeClicked/route_violets.png";
import RoutePoint_DEF from "../../img/icons/routePoint_DEF.png";
import RoutePoint_CLICKED from "../../img/icons/routePoint_CLICKED.png";

const scaleFactor = 0.5;

const images: Record<PlaceSubtype, Record<UserStatus, Record<SelectedStatus, string>>> = {
    [PlaceSubtype.nr1]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: PlaceSubtypeNr1_DEF,
            [SelectedStatus.Selected]: PlaceSubtypeNr1_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: PlaceSubtypeNr1_ROUTE,
            [SelectedStatus.Selected]: PlaceSubtypeNr1_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: PlaceSubtypeNr1_VISITED,
            [SelectedStatus.Selected]: PlaceSubtypeNr1_VISITED_CLICKED
        }
    },
    [PlaceSubtype.AtputasVieta]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: AtputasVieta_DEF,
            [SelectedStatus.Selected]: AtputasVieta_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: AtputasVieta_ROUTE,
            [SelectedStatus.Selected]: AtputasVieta_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: AtputasVieta_VISITED,
            [SelectedStatus.Selected]: AtputasVieta_VISITED_CLICKED
        }
    },
    [PlaceSubtype.DabasTaka]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: DabasTaka_DEF,
            [SelectedStatus.Selected]: DabasTaka_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: DabasTaka_ROUTE,
            [SelectedStatus.Selected]: DabasTaka_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: DabasTaka_VISITED,
            [SelectedStatus.Selected]: DabasTaka_VISITED_CLICKED
        }
    },
    [PlaceSubtype.AktivaAtputa_VeloTaka]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: AktivaAtputa_DEF,
            [SelectedStatus.Selected]: AktivaAtputa_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: AktivaAtputa_ROUTE,
            [SelectedStatus.Selected]: AktivaAtputa_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: AktivaAtputa_VISITED,
            [SelectedStatus.Selected]: AktivaAtputa_VISITED_CLICKED
        }
    },
    [PlaceSubtype.DabasApskatesObjekts]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: DabasApskatesObjekts_DEF,
            [SelectedStatus.Selected]: DabasApskatesObjekts_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: DabasApskatesObjekts_ROUTE,
            [SelectedStatus.Selected]: DabasApskatesObjekts_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: DabasApskatesObjekts_VISITED,
            [SelectedStatus.Selected]: DabasApskatesObjekts_VISITED_CLICKED
        }
    },
    [PlaceSubtype.KulturvesturisksApskatesObjekts]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: KulturvesturisksApskatesObjekts_DEF,
            [SelectedStatus.Selected]: KulturvesturisksApskatesObjekts_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: KulturvesturisksApskatesObjekts_ROUTE,
            [SelectedStatus.Selected]: KulturvesturisksApskatesObjekts_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: KulturvesturisksApskatesObjekts_VISITED,
            [SelectedStatus.Selected]: KulturvesturisksApskatesObjekts_VISITED_CLICKED
        }
    },
    [PlaceSubtype.MammadabaGalamerki]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: MammadabaGalamerki_DEF,
            [SelectedStatus.Selected]: MammadabaGalamerki_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: MammadabaGalamerki_ROUTE,
            [SelectedStatus.Selected]: MammadabaGalamerki_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: MammadabaGalamerki_VISITED,
            [SelectedStatus.Selected]: MammadabaGalamerki_VISITED_CLICKED
        }
    },
    [PlaceSubtype.SkatuTornis]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: SkatuTornis_DEF,
            [SelectedStatus.Selected]: SkatuTornis_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: SkatuTornis_ROUTE,
            [SelectedStatus.Selected]: SkatuTornis_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: SkatuTornis_VISITED,
            [SelectedStatus.Selected]: SkatuTornis_VISITED_CLICKED
        }
    },
    [PlaceSubtype.AktivaAtputa_Orientesanas]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: AktivaAtputa_DEF,
            [SelectedStatus.Selected]: AktivaAtputa_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: AktivaAtputa_ROUTE,
            [SelectedStatus.Selected]: AktivaAtputa_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: AktivaAtputa_VISITED,
            [SelectedStatus.Selected]: AktivaAtputa_VISITED_CLICKED
        }
    },
    [PlaceSubtype.Udensturistiem]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: Udensturistiem_DEF,
            [SelectedStatus.Selected]: Udensturistiem_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: Udensturistiem_ROUTE,
            [SelectedStatus.Selected]: Udensturistiem_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: Udensturistiem_VISITED,
            [SelectedStatus.Selected]: Udensturistiem_VISITED_CLICKED
        }
    },
    [PlaceSubtype.MarsrutiIedvesmai]: {
        [UserStatus.Default]: {
            [SelectedStatus.Default]: PlaceSubtypeNr1_DEF,
            [SelectedStatus.Selected]: PlaceSubtypeNr1_DEF_CLICKED
        },
        [UserStatus.Route]: {
            [SelectedStatus.Default]: PlaceSubtypeNr1_ROUTE,
            [SelectedStatus.Selected]: PlaceSubtypeNr1_ROUTE_CLICKED
        },
        [UserStatus.Visited]: {
            [SelectedStatus.Default]: PlaceSubtypeNr1_VISITED,
            [SelectedStatus.Selected]: PlaceSubtypeNr1_VISITED_CLICKED
        }
    }
};

const routeImages: Record<SelectedStatus, string> = {
    [SelectedStatus.Default]: Route_DEF,
    [SelectedStatus.Selected]: Route_CLICKED
};

type SelectedStatusCache = Map<SelectedStatus, Style>;
type UserStatusCache = Map<UserStatus, SelectedStatusCache>;
type PlaceSubtypeCache = Map<PlaceSubtype, UserStatusCache>;
const cache: PlaceSubtypeCache = new Map();

const ensureSymbol = (placeSubtype: PlaceSubtype, userStatus: UserStatus, selectedStatus: SelectedStatus): void => {
    let userStatusCache: UserStatusCache;
    if (cache.has(placeSubtype)) {
        userStatusCache = cache.get(placeSubtype);
    } else {
        userStatusCache = new Map();
        cache.set(placeSubtype, userStatusCache);
    }
    let selectedStatusCache: SelectedStatusCache;
    if (userStatusCache.has(userStatus)) {
        selectedStatusCache = userStatusCache.get(userStatus);
    } else {
        selectedStatusCache = new Map();
        userStatusCache.set(userStatus, selectedStatusCache);
    }
    if (!selectedStatusCache.has(selectedStatus)) {
        const style = new Style({
            image: new Icon({
                src: images[placeSubtype][userStatus][selectedStatus],
                scale: 1 * scaleFactor
            })
        });
        selectedStatusCache.set(selectedStatus, style);
    }
};

export const getMiniSymbol = (
    placeSubtype: PlaceSubtype,
    visitedStatus: 0 | 1,
    routeStatus: 0 | 1,
    selectedStatus: SelectedStatus
): Style => {
    const userStatus = routeStatus ? 2 : visitedStatus ? 1 : 0;
    ensureSymbol(placeSubtype, userStatus, selectedStatus);
    return cache.get(placeSubtype).get(userStatus).get(selectedStatus);
};

export const getMiniRouteSymbol = (
    id: RouteLayers,
    selectedStatus: SelectedStatus,
    type?: 0 | 1,
    route?: 0 | 1
): Style => {
    if (id === RouteLayers.Route) {
        return selectedStatus === SelectedStatus.Default
            ? new Style({
                  image: new Icon({
                      src: routeImages[selectedStatus],
                      scale: scaleFactor
                  })
              })
            : new Style({});
    } else if (id === RouteLayers.RoutePoints) {
        if (type === RoutePointDataSource.LVM) {
            return new Style({});
        } else {
            if (route) {
                return selectedStatus === SelectedStatus.Selected
                    ? new Style({
                          image: new Icon({
                              src: RoutePoint_CLICKED,
                              scale: 0.78 * scaleFactor
                          })
                      })
                    : new Style({
                          image: new Icon({
                              src: RoutePoint_DEF,
                              scale: scaleFactor
                          })
                      });
            } else {
                return new Style({});
            }
        }
    } else if (id === RouteLayers.RouteTrack) {
        return selectedStatus === SelectedStatus.Selected
            ? new Style({
                  stroke: new Stroke({
                      color: "#724CF9",
                      width: 3 * scaleFactor
                  })
              })
            : new Style({});
    }
};
